export const mockAuditTaskData = {
  data: {
    taskAuditInfoById: [
      {
        action: 'Added',
        actionDate: '2023-04-17T07:10:55.963Z',
        field: 'Field Inspector',
        newValue: 'newName',
        oldValue: '',
        userName: 'mock username',
        userRole: 'Lead Inspector',
      },
      {
        action: 'Updated',
        actionDate: '2023-04-07T07:10:55.963Z',
        field: 'Task Status',
        newValue: '',
        oldValue: null,
        userName: 'mock new name',
        userRole: 'Lead Inspector',
      },
    ],
  },
};

export const mockDeficiencyAuditData = {
  data: {
    deficiencyAuditInfoById: [
      {
        action: 'Added',
        actionDate: '2022-04-27T07:38:57.510Z',
        field: 'Deficiency',
        newValue: 'testet1',
        oldValue: '',
        userName: 'jest user',
        userRole: 'Field Inspector',
      },
      {
        action: 'Added',
        actionDate: '2022-02-27T07:38:57.510Z',
        field: 'Deficiency',
        newValue: 'testet1',
        oldValue: '',
        userName: 'jest user',
        userRole: 'Field Inspector',
      },
      {
        action: 'Added',
        actionDate: '2022-02-27T07:38:57.510Z',
        field: 'Comments',
        newValue: 'testet1',
        oldValue: 'oldValue',
        userName: 'jest user',
        userRole: 'Field Inspector',
      },
      {
        action: 'Added',
        actionDate: '2022-02-27T07:38:57.510Z',
        field: 'Urgency',
        newValue: 'Urgency | 5 - Medium',
        oldValue: 'Urgency | 1 - Low',
        userName: 'jest user',
        userRole: 'Field Inspector',
        inspectionId: 1202,
      },
      {
        action: 'Added',
        actionDate: '2022-02-27T07:38:57.510Z',
        field: 'Risk',
        newValue: 'testet1',
        oldValue: '',
        userName: 'jest user',
        userRole: 'Field Inspector',
      },
      {
        action: 'Added',
        actionDate: '2022-02-27T07:38:57.510Z',
        field: 'IsCompletedDuringInspection',
        newValue: 'testet1',
        oldValue: '',
        userName: 'jest user',
        userRole: 'Field Inspector',
      },
      {
        action: 'Added',
        actionDate: '2022-02-27T07:38:57.510Z',
        field: 'Repair Factor',
        newValue: 'Low',
        oldValue: '',
        userName: 'jest user',
        userRole: 'Field Inspector',
      },
    ],
  },
};
